import { useQuery } from "react-query";
import loanManagement, {
  LoanManagementResponse,
} from "../services/loanManagement";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import { LoanStatus } from "../constant/enum";

function useLoanManagement(
  token: string,
  type: LoanStatus,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState,
  noteId?: string
) {
  return useQuery<LoanManagementResponse>({
    queryKey: [
      "loan-management",
      type,
      pagination,
      JSON.stringify(columnFilters),
      sorting,
      noteId,
    ],
    queryFn: () =>
      loanManagement({
        token,
        type,
        noteId,
        pagination,
        columnFilters,
        sorting,
      }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useLoanManagement;
